import * as React from 'react';
import queryString from 'query-string';
import styles from './Map.module.css';
import TokenService from '~services/TokenService';
import { WEBVIEW_MAP_URL } from '~config/map';
import { getCurrentLanguage } from '~/i18n';

export interface MapProps {
  page?:
    | 'detail'
    | 'indoor-map'
    | 'beacon-map'
    | 'map-position'
    | 'geofence-editor'
    | 'installer-validate-map'
    | 'outdoor-draw-tool'
    | 'insert-markers-indoor'
    | 'draw-tool'
    | 'zone-selector'
    | 'geo-draw-tool'
    | 'geo-map-position'
    | 'geo-map-detail-view'
    | 'geo-plane-create';
  lat?: number;
  long?: number;
  accuracy?: number;
  siteId?: number | string;
  withBeaconMac?: boolean;
  withBeaconCoordinates?: boolean;
  ignoreMapClick?: boolean;
  height?: number | string;
  planeId?: number | string;
  floorSelect?: boolean;
  type?: string;
  planeUuid?: string;
  zoneUuid?: string;
  safeAreaTop?: number;
  showZoom?: boolean;
  showRooms?: boolean;
  showRoomLabels?: boolean;
  withGoBack?: boolean;
  canInsertMarker?: boolean;
  zoom?: number;
  /** Off while scrubbing through positions, so each step lands instantly. */
  animate?: boolean;
  onFloorLoaded?: (e: any) => void;
}

const Map = React.forwardRef<HTMLIFrameElement, MapProps>(
  (
    {
      page,
      planeId,
      lat,
      long,
      accuracy,
      siteId,
      ignoreMapClick,
      planeUuid,
      floorSelect,
      height,
      type,
      withBeaconMac,
      zoneUuid,
      withBeaconCoordinates,
      safeAreaTop,
      showZoom,
      animate,
    },
    ref
  ) => {
    const lang = getCurrentLanguage();
    const MapPath = React.useMemo(() => {
      const query = queryString.stringify({
        lang,
        planeId,
        page,
        lat,
        long,
        accuracy,
        siteId,
        ignoreMapClick,
        planeUuid,
        floorSelect,
        zoneUuid,
        type,
        withBeaconMac,
        withBeaconCoordinates,
        safeAreaTop,
        showZoom,
        animate,
        token: TokenService.token?.token,
        endpoint: TokenService.baseUrl.apiUrl,
      });
      return `${WEBVIEW_MAP_URL}?${query}`;
    }, [lang]);

    return (
      <div className={styles.MapEmbed}>
        <iframe key={MapPath} ref={ref} style={{ height }} src={MapPath} allow="geolocation" />
      </div>
    );
  }
);

export default Map;
